<template>
	<div class="sg-gold-price-bar" :class="{ 'sg-gold-price-bar--sticky': sticky }">
		<v-container class="py-2">
			<v-row align="center" justify="center" no-gutters>
				<v-col cols="auto" class="d-flex align-center">
					<v-icon color="#D4AF37" class="ml-2 sg-pulse">mdi-gold</v-icon>
					<span class="sg-price-label">قیمت هر گرم طلای ۱۸ عیار:</span>
					<span class="sg-price-value mr-2">{{ formattedPrice }} <small>تومان</small></span>
					<span v-if="content.lastUpdate" class="sg-price-update d-none d-sm-inline">— بروزرسانی: {{ content.lastUpdate }}</span>
				</v-col>
				<v-col cols="auto" v-if="editable">
					<v-btn x-small outlined color="#D4AF37" class="mr-2" @click="edit()">
						<v-icon left x-small>mdi-pencil</v-icon>
						ویرایش قیمت
					</v-btn>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="settingsDialog" persistent max-width="420px">
			<v-card>
				<v-card-title>ویرایش قیمت طلا</v-card-title>
				<v-card-text>
					<v-text-money v-model.number="settings.price" label="قیمت هر گرم (تومان)" type="number" outlined dense />
					<v-text-field v-model="settings.lastUpdate" label="تاریخ بروزرسانی" outlined dense hint="مثال: ۱۴۰۴/۰۶/۲۴" />
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="settingsDialog = false">بستن</v-btn>
					<v-btn color="primary" :loading="submitEditLoading" @click="submitEdit">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import { cloneDeep } from 'lodash'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'GoldPriceBar',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean },
			sticky: { type: Boolean, default: true },
		},
		data: () => ({
			localData: null,
			settings: {},
			settingsDialog: false,
			submitEditLoading: false,
		}),
		computed: {
			...get('siteConfig', ['customerCode']),
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			},
			formattedPrice() {
				return Number(this.content.price || 0).toLocaleString('fa-IR')
			},
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content),
				}
			} else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent(),
				}
			}
			this.$emit('update', this.content.price || 0)
		},
		methods: {
			defaultContent() {
				return {
					price: 23000000,
					lastUpdate: new Date().toLocaleDateString('fa-IR'),
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				const data = cloneDeep(this.localData)
				data.content = JSON.stringify(this.settings)
				api.post('admin/SiteContent/CreateUpdate', data)
					.then(() => {
						this.localData.content = cloneDeep(this.settings)
						toast.success('قیمت طلا با موفقیت ذخیره شد.')
						this.settingsDialog = false
						this.$emit('update', this.content.price || 0)
					})
					.catch(err => toast.error(err.message))
					.finally(() => { this.submitEditLoading = false })
			},
		},
	}
</script>

<style lang="scss"
	scoped>
		.sg-gold-price-bar {
			background: linear-gradient(90deg, #1a1a1a, #2c2416, #1a1a1a);
			color: #fff;
			z-index: 5;

			&--sticky {
				position: sticky;
				top: 72px;
			}
		}

		.sg-price-label {
			font-size: 0.9rem;
			color: rgba(255, 255, 255, 0.8);
		}

		.sg-price-value {
			font-size: 1.15rem;
			font-weight: 700;
			color: #D4AF37;

			small {
				font-size: 0.75rem;
				font-weight: 400;
				opacity: 0.8;
			}
		}

		.sg-price-update {
			font-size: 0.75rem;
			color: rgba(255, 255, 255, 0.5);
			margin-right: 12px;
		}

		.sg-pulse {
			animation: sgPulse 2s ease-in-out infinite;
		}

		@keyframes sgPulse {

			0%,
			100% {
				opacity: 1;
				transform: scale(1);
			}

			50% {
				opacity: 0.7;
				transform: scale(1.1);
			}
		}


	</style>
